import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SingleSelectFilterModal from "../../../ui/components/filters/SingleSelectFilterModal";

const ZoneFilterModal = ({
  isOpen,
  onClose,
  onApply,
  currentZoneFilter,
  zoneOptions = [],
}) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => [
      { label: t("All"), value: "all" },
      ...zoneOptions.map((option) => ({
        value: String(option.value),
        label: option.label,
        suffix: option.positioning ? `(${option.positioning})` : undefined,
      })),
    ],
    [t, zoneOptions],
  );

  return (
    <SingleSelectFilterModal
      isOpen={isOpen}
      onClose={onClose}
      onApply={onApply}
      title={t("settingsClients.filterZones")}
      options={options}
      currentValue={
        currentZoneFilter == null ? "all" : String(currentZoneFilter)
      }
      maxWidth="560px"
    />
  );
};

export default ZoneFilterModal;
